<template>
  <div class="home">
    <el-row :gutter="20">
      <!-- 轮播图 -->
      <!-- <el-col :span="12" style="width: 50%">
        <el-card class="home-image-card">
          <swiper class="swiper" :options="swiperOption">
            <swiper-slide
              v-for="(img) in channelImages"
              :key="img.articleId"
            >
              <div class="swiper-slide-wrapper">
                <el-image :src="showPicture(img.showPicture)" />
                <div class="swiper-slide-wrapper-title">
                  <span>{{ img.articleTitle }}</span>
                </div>
              </div>
            </swiper-slide>
            <div
              class="swiper-pagination swiper-pagination-bullets"
              slot="pagination"
            ></div>
          </swiper>
        </el-card>
      </el-col> -->
      <el-col :span="12" style="width: 50%">
        <el-card shadow="never" class="home-article-card">
          <template slot="header">
            <div class="themeButton">国务院文件</div>
            <a class="extra" @click="articleMoreLeft">更多</a>
          </template>
          <ul class="articleUls">
            <li
              v-for="item in articleListLeft"
              :key="item.articleTitle"
              @click="checkArticleInfo(item.articleId)"
            >
              <div
                :class="
                  item.topSign == 1 ? 'articlHeader topTxt' : 'articlHeader'
                "
              >
                <el-tooltip
                  effect="light"
                  :content="item.articleTitle"
                  placement="top-start"
                  class="articleTitleItem"
                >
                  <p class="articleTitle">{{ item.articleTitle }}</p>
                </el-tooltip>
                <p>{{ item.publishTime }}</p>
              </div>
              <div class="articleCenter">
                <p>{{ item.content }}</p>
              </div>
              <div class="reading">
                阅读量：{{ item.visits ? item.visits : "0" }}
              </div>
            </li>
            <!-- <li
              class="articleLi"
              v-for="item in articleListLeft"
              :key="item.articleId"
            >
              <el-row>
                <el-col :span="4">
                  <span class="articleType">{{ item.extendFeild3 }}</span>
                </el-col>
                <el-col :span="20" class="articleTitle">
                  <span
                    v-if="item.articleTitle.length <= 20"
                    @click="checkArticleInfo(item.articleId)"
                    class="articleTitleItem"
                    >{{ item.articleTitle }}</span
                  >
                  <el-tooltip
                    v-else
                    effect="light"
                    :content="item.articleTitle"
                    placement="top-start"
                    class="articleTitleItem"
                  >
                    <span @click="checkArticleInfo(item.articleId)">{{
                      item.articleTitle
                    }}</span>
                  </el-tooltip>
                </el-col>
              </el-row>
            </li> -->
          </ul>
        </el-card>
      </el-col>
      <el-col :span="12" style="width: 50%">
        <el-card shadow="never" class="home-article-card">
          <template slot="header">
            <div class="themeButton">通知公示</div>
            <a class="extra" @click="articleMore">更多</a>
          </template>
          <ul class="articleUl">
            <li
              class="articleLi"
              v-for="item in articleList"
              :key="item.articleId"
            >
              <el-row>
                <el-col :span="2">
                  <span class="articleType">{{ item.extendFeild3 }}</span>
                </el-col>
                <el-col :span="22" class="articleTitle">
                  <span
                    v-if="item.articleTitle.length <= 23"
                    @click="checkArticleInfo(item.articleId)"
                    class="articleTitleItem"
                    >{{ item.articleTitle }}</span
                  >
                  <el-tooltip
                    v-else
                    effect="light"
                    :content="item.articleTitle"
                    placement="top-start"
                    class="articleTitleItem"
                  >
                    <span @click="checkArticleInfo(item.articleId)">{{
                      item.articleTitle
                    }}</span>
                  </el-tooltip>
                </el-col>
              </el-row>
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col class="margin-top-20 rows">
        <el-card shadow="never" class="home-article-card">
          <quick-entry
            :dataList="quickEntry"
            style="margin: 5px 0; display: flex"
          ></quick-entry>
        </el-card>
      </el-col>
      <el-col :span="24" class="margin-top-15">
        <el-carousel
          indicator-position="outside"
          class="home-carousel"
          ref="carousel"
        >
          <el-carousel-item v-for="item in carouselList" :key="item.channelId">
            <div
              v-if="item.imgurl != '' || item.imgurl"
              @click="runSpecial(item)"
            >
              <img :src="productionBaseUrl + item.imgurl" />
            </div>
            <div v-else @click="runSpecial(item)">
              <img
                :src="
                  productionBaseUrl +
                  '/api/channel/showChannelPic?channelId=' +
                  item.channelId
                "
              />
            </div>
          </el-carousel-item>
        </el-carousel>
      </el-col>

      <el-col :span="24" class="margin-top-15">
        <el-card shadow="never" class="home-article-card">
          <quick-entry
            :dataList="checkList"
            style="margin: 5px 0"
          ></quick-entry>
        </el-card>
      </el-col>
      <el-col :span="24" class="margin-top-15 margin-bottom-20">
        <el-card
          shadow="never"
          class="home-article-card needMyself"
          style="min-height: 350px; display: flex; flex-direction: column"
        >
          <information-inquiry
            :typeList="informationInquiryList"
          ></information-inquiry>
        </el-card>
      </el-col>
    </el-row>
    <wave></wave>
  </div>
</template>

<script>
import "swiper/css/swiper.css";
import { URL_CHANNEL_LIST_BYIDS, URL_Channel_Type } from "../../utils/api";
import {
  channelIdList,
  homeCheckList,
  // homeQuickEntry,
  // informationInquiryList,
} from "../../utils/staticDict";
import util from "../../utils/util";
import { productionBaseUrl } from "../../utils/axiosUrl";
import wave from "../../components/wave";
export default {
  name: "Home",
  components: {
    "quick-entry": () => import("@/components/Home/QuickEntrysHome.vue"),
    "information-inquiry": () =>
      import("@/components/Home/InformationInquiry/InformationInquiry.vue"),
    wave: () => import("@/components/wave"),
  },
  data() {
    return {
      channelImages: [], //轮播图列表
      query: {
        currentPage: 1,
        pageSize: 5,
      },
      productionBaseUrl: productionBaseUrl + ":9002",
      swiperOption: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          circular: true,
        },
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom"></span>`;
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      articleList: [], //文章列表
      articleListLeft: [], //左侧文章列表
      quickEntry: [],
      carouselList: [
        // {
        //   id: "1",
        //   src: require("@/assets/carousel_01.jpg"),
        //   link: "",
        //   htt: "http://gjzwfw.www.gov.cn/col/col644/index.html",
        // },
        // {
        //   id: "2",
        //   src: require("@/assets/carousel_03.jpg"),
        //   link: "",
        //   htt: "http://gjzwfw.www.gov.cn/",
        // },
        // {
        //   id: "3",
        //   src: require("@/assets/carousel_02.jpg"),
        //   link: "/home/Emergencies",
        //   htt: "#",
        // },
      ],
      checkList: homeCheckList,
      informationInquiryList: [],
    };
  },
  async created() {
    await this.getInformationInquiryList();
  },
  mounted() {
    this.getChannelListByIds();
    this.getLeftChannelListByIds();
    this.channelTypeData();
    this.getHomeQuickEntry();
  },
  methods: {
    runBar() {
      // window.location.replace('b.html');
      // window.location.replace("Home.vue");
    },
    //获取专题数据
    channelTypeData() {
      let Url = util.getAjaxUrl("axiosThree");
      this.$http.get(Url + URL_Channel_Type).then((resp) => {
        let datas = resp.data.data;
        console.log(datas);
        this.carouselList = datas;
      });
    },
    getHomeQuickEntry() {
      let ajaxUrl = util.getAjaxUrl("axiosThree");
      let params = {
        modletype: "跳转链接",
      };
      this.$http
        .post(ajaxUrl + `/api/queryProtalServiceConfigList`, params)
        .then((res) => {
          if (res.data.code == 200) {
            let homeQuickEntryObject = {};
            res.data.data.data[0].children.forEach((element) => {
              homeQuickEntryObject = {};
              homeQuickEntryObject.value = element.id;
              homeQuickEntryObject.label = element.name;
              homeQuickEntryObject.icon = element.icon;
              homeQuickEntryObject.name = element.url;
              homeQuickEntryObject.path = element.path;
              if (element.flag == 1) {
                this.quickEntry.push(homeQuickEntryObject);
              }
            });
          }
        });
    },
    async getInformationInquiryList() {
      let ajaxUrl = util.getAjaxUrl("axiosThree");
      let params = {
        modletype: "公共服务",
      };
      const res = await this.$http.post(
        ajaxUrl + `/api/queryProtalServiceConfigList`,
        params
      );
      if (res.data.code == 200) {
        let InformationInquiryListObject = {};
        let InformationInquiryListObject1 = {};
        res.data.data.data[0].children.forEach((element) => {
          InformationInquiryListObject = {
            label: "",
            value: [],
          };
          InformationInquiryListObject.label = element.name;
          InformationInquiryListObject.id = element.id;
          let id = 1;
          element.children.forEach((el) => {
            InformationInquiryListObject1 = {};
            InformationInquiryListObject1.title = el.name;
            InformationInquiryListObject1.icon_class = el.icon;
            InformationInquiryListObject1.only = el.noly;
            InformationInquiryListObject1.url = el.url;
            InformationInquiryListObject1.path = el.path;
            InformationInquiryListObject1.id = id;
            id++;
            if (el.name == "中国历史文化名城名单") {
              InformationInquiryListObject1.type = "cityName";
            }
            if (el.name == "中国历史文化名镇名单") {
              InformationInquiryListObject1.type = "townName";
            }
            if (el.name == "中国历史文化名村名单") {
              InformationInquiryListObject1.type = "villageName";
            }
            if (el.name == "中国历史文化街区名单") {
              InformationInquiryListObject1.type = "streetName";
            }
            if (el.flag == 1) {
              InformationInquiryListObject.value.push(
                InformationInquiryListObject1
              );
            }
          });
          if (element.flag == 1) {
            this.informationInquiryList.push(InformationInquiryListObject);
          }
        });
        console.log("this.informationInquiryList", this.informationInquiryList);
      }
    },
    getChannelListByIds() {
      let imagesParams = {
        ...this.query,
        t: {
          channels: [channelIdList.channelImages],
          publishSign: "2",
        },
      };
      let articleParams = {
        ...this.query,
        t: {
          channels: [channelIdList.notice, channelIdList.publicity],
          publishSign: "2",
        },
      };
      this.resolveMethod(imagesParams).then((resp) => {
        if (resp.data.success) {
          this.channelImages = resp.data.data.data;
        } else {
          this.$alert("获取轮播图失败");
        }
      });
      this.resolveMethod(articleParams).then((resp) => {
        if (resp.data.success) {
          this.articleList = resp.data.data.data;
        } else {
          this.$alert("获取栏目文章列表失败");
        }
      });
    },
    resolveMethod(params) {
      let Url = util.getAjaxUrl("axiosThree");
      return new Promise((resolver, reject) => {
        this.$http
          .post(Url + URL_CHANNEL_LIST_BYIDS, params)
          .then((resp) => {
            resolver(resp);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    runSpecial(row) {
      if (row.jumpurl) {
        window.open(row.jumpurl);
      } else {
        let design = this.$router.resolve({
          path: "/home/Emergencies",
          query: {
            imgurl: row.imgurl,
            channelId: row.channelId,
            channelName: row.channelName,
          },
        });
        window.open(design.href, "_blank");
      }
    },
    articleMore() {
      this.$router.push("/article/list");
    },
    articleMoreLeft() {
      this.$router.push("/article/listLeft");
    },
    checkArticleInfo(id) {
      let design = this.$router.resolve("/article/content?articleId=" + id);
      window.open(design.href, "_blank");
    },
    getLeftChannelListByIds() {
      let articleParams = {
        ...this.query,
        t: {
          channels: [channelIdList.countryFile],
          publishSign: "2",
        },
      };
      this.resolveMethod(articleParams).then((resp) => {
        if (resp.data.success) {
          let datas = resp.data.data.data;
          datas.map((item) => {
            let times = item.publishTime.substring(0, 10);
            // let contents = item.content.match(/[\u4e00-\u9fa5]/g).join("");
            this.$set(item, "publishTime", times);
            // this.$set(item, "content", contents);
          });
          console.log(datas);
          this.articleListLeft = datas;
        } else {
          this.$alert("获取国务院文件列表失败");
        }
      });
    },
  },
  computed: {
    showPicture() {
      return function (value) {
        let Url = util.getAjaxUrl("axiosThree");
        let path = Url + "/api/article/showFile?path=" + value;
        return path;
      };
    },
  },
};
</script>

<style scoped lang="less">
@import "Home";
/deep/ .needMyself {
  .el-card__body {
    flex-grow: 1;
    display: flex;
    padding: 20px !important;
    flex-direction: column;
    div:first-child {
      flex-grow: 1;
    }
  }
}
.rows {
  /deep/ .el-row {
    margin: 27px 0 !important;
  }
}
.articleUl {
  height: 26.1rem !important;
}
.articleUls {
  height: 26.1rem;
  overflow: hidden;
  list-style: none;
  padding: 0px 10px;
  li {
    padding: 0 0.5em 1.5em 0.5em;
    border-bottom: 1px silver dotted;
    position: relative;
    margin-bottom: 0.5em;
    cursor: pointer;
  }
}
.articleCenter {
  min-height: 4em;
  font-size: 13px;
  p {
    color: gray;
    line-height: 21px;
    padding-right: 0.9em;
    // text-align-last: 500px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.articlHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #606266;
  .articleTitle {
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  p {
    font-size: 16px;
    font-weight: 600;
  }
}
.reading {
  position: absolute;
  font-size: 13px;
  bottom: 0.5em;
  right: 0.8em;
  color: #555555;
}
.topTxt {
  color: @theme-color;
}
</style>
